import React from 'react'
import { Box, Text, Flex } from '@chakra-ui/react'

import { getClientFullName } from '~utils/helpers'
import { ActionItemFieldsFragment, FormType } from '~graphql/generated/graphql'
import { FormSubmittedActionItem } from '~components/pending-actions/pending-item-rows/form-submitted/types'
import { formatHumanReadableDate } from '~components/chats/chat/messages-list/message-content/message-helpers'
import FormSubmittedActions from '~components/pending-actions/pending-item-rows/form-submitted/form-submitted-actions'

interface Props {
    actionItem: ActionItemFieldsFragment
}

export default function FormSubmittedContent({ actionItem }: Props) {
    if (!actionItem.client_form) {
        return <Box display="none" />
    }

    const { client, patient, form, client_completed_at } =
        actionItem.client_form

    return (
        <Box w="full">
            <Flex
                justify="space-between"
                alignItems="center"
                w="full"
                direction={{ base: 'column', md: 'row' }}
                gap={3}
            >
                <Box flex={1}>
                    <Flex justify="space-between">
                        {form.form_type == FormType.Client ? (
                            <Text fontSize="sm" fontWeight="semibold">
                                {client
                                    ? getClientFullName(client)
                                    : 'A New Client'}{' '}
                                submitted {form.name}
                            </Text>
                        ) : (
                            <Text fontSize="sm" fontWeight="semibold">
                                {form.name} submitted for{' '}
                                {patient ? patient.name : 'a New Patient'}
                            </Text>
                        )}
                    </Flex>
                    <Text fontSize="xs" color="gray.600" noOfLines={1}>
                        Submitted{' '}
                        {formatHumanReadableDate(client_completed_at || 0)}
                    </Text>
                </Box>
                <FormSubmittedActions
                    actionItem={actionItem as FormSubmittedActionItem}
                    isSmall
                />
            </Flex>
        </Box>
    )
}
